import ReactApexChart from "react-apexcharts";
import { ApexOptions } from "apexcharts";

interface ChartProps {
  options: ApexOptions;
  series: ApexAxisChartSeries | ApexNonAxisChartSeries;
  type:
    | "line"
    | "area"
    | "bar"
    | "pie"
    | "donut"
    | "scatter"
    | "bubble"
    | "heatmap"
    | "candlestick"
    | "boxPlot"
    | "radar"
    | "polarArea"
    | "rangeBar"
    | "rangeArea"
    | "radialBar"
    | "treemap";
  height?: number;
}

export default function ChartWrapper(props: ChartProps): JSX.Element {
  return (
    <ReactApexChart
      options={props.options}
      series={props.series}
      type={props.type}
      height={props.height}
    />
  );
}
